import { __assign, __generator } from "tslib";
import { cloneDeep, pick } from 'lodash-es';
import { select, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../constants/actionTypes';
import { scrollPositions } from '../middlewares/scrollPosition';
import { getPathnameFromState, isInHandoffMode } from '../selectors';
import isBrowserInFullScreenMode from '../utils/isBrowserInFullScreenMode';
import * as locationUtils from '../utils/location';
export function syncHistory(history) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery('*', function (action) {
                    var applicationState, _a, screenID, pathname, transition, screenTransition, locationObject, projectID;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, select()];
                            case 1:
                                applicationState = _b.sent();
                                _a = action.type;
                                switch (_a) {
                                    case actionTypes.LOAD_HOTSPOTS_DONE: return [3 /*break*/, 2];
                                    case actionTypes.LOAD_PROJECT_PREVIEW_DONE: return [3 /*break*/, 2];
                                    case actionTypes.SHOW_OVERLAY: return [3 /*break*/, 5];
                                    case actionTypes.SHOW_HANDOFF: return [3 /*break*/, 5];
                                    case actionTypes.HIDE_HANDOFF: return [3 /*break*/, 5];
                                    case actionTypes.HIDE_COMMENTS: return [3 /*break*/, 5];
                                    case actionTypes.SHOW_GRID: return [3 /*break*/, 5];
                                    case actionTypes.HIDE_GRID: return [3 /*break*/, 7];
                                    case actionTypes.HIDE_OVERLAY: return [3 /*break*/, 11];
                                    case actionTypes.SHOW_SCREEN: return [3 /*break*/, 13];
                                    case actionTypes.SET_PROJECT: return [3 /*break*/, 15];
                                }
                                return [3 /*break*/, 18];
                            case 2:
                                screenID = locationUtils.parse(history.location).screenID;
                                if (!!screenID) return [3 /*break*/, 4];
                                return [4 /*yield*/, select(getPathnameFromState)];
                            case 3:
                                pathname = _b.sent();
                                history.replace(__assign(__assign({}, history.location), { pathname: pathname }));
                                _b.label = 4;
                            case 4: return [3 /*break*/, 19];
                            case 5: return [4 /*yield*/, updateLocation(history)];
                            case 6:
                                _b.sent();
                                return [3 /*break*/, 19];
                            case 7:
                                if (!(history.action === 'REPLACE')) return [3 /*break*/, 9];
                                // It seems to be action is only REPLACE when grid opened via deep
                                // link.
                                return [4 /*yield*/, updateLocation(history, 'replace')];
                            case 8:
                                // It seems to be action is only REPLACE when grid opened via deep
                                // link.
                                _b.sent();
                                return [3 /*break*/, 10];
                            case 9:
                                // Not opened from a deep link so just navigate back to where the grid
                                // was opened from
                                history.goBack();
                                _b.label = 10;
                            case 10: return [3 /*break*/, 19];
                            case 11:
                                transition = applicationState.screen.previousOverlayHotspot.transition;
                                // TODO do we want this for overlays?
                                // updateCurrentLocationState(history, { scrollPositions });
                                return [4 /*yield*/, updateLocationWithState(history, {
                                        overlayTransition: transition,
                                    })];
                            case 12:
                                // TODO do we want this for overlays?
                                // updateCurrentLocationState(history, { scrollPositions });
                                _b.sent();
                                return [3 /*break*/, 19];
                            case 13:
                                screenTransition = applicationState.screen.transition;
                                updateCurrentLocationState(history, { scrollPositions: scrollPositions });
                                return [4 /*yield*/, updateLocationWithState(history, {
                                        screenTransition: screenTransition,
                                    })];
                            case 14:
                                _b.sent();
                                return [3 /*break*/, 19];
                            case 15:
                                locationObject = history.location;
                                projectID = void 0;
                                if (locationObject) {
                                    (projectID = locationUtils.parse(locationObject).projectID);
                                }
                                if (!(isBrowserInFullScreenMode() || !projectID)) return [3 /*break*/, 17];
                                return [4 /*yield*/, updateLocation(history)];
                            case 16:
                                _b.sent();
                                _b.label = 17;
                            case 17: return [3 /*break*/, 19];
                            case 18: return [3 /*break*/, 19];
                            case 19: return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateLocation(history, action) {
    var pathname, inHandoff, newLocationState, newLocation;
    if (action === void 0) { action = 'push'; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getPathnameFromState)];
            case 1:
                pathname = _a.sent();
                if (!(pathname !== history.location.pathname &&
                    "".concat(pathname, "/") !== history.location.pathname)) return [3 /*break*/, 3];
                return [4 /*yield*/, select(isInHandoffMode)];
            case 2:
                inHandoff = _a.sent();
                newLocationState = { inHandoff: inHandoff };
                newLocation = getNewLocation(history, { pathname: pathname });
                history[action](newLocation, newLocationState);
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
function updateLocationWithState(history, stateObj) {
    var pathname, inHandoff, newLocationState, newLocation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getPathnameFromState)];
            case 1:
                pathname = _a.sent();
                return [4 /*yield*/, select(isInHandoffMode)];
            case 2:
                inHandoff = _a.sent();
                newLocationState = Object.assign({}, stateObj, { inHandoff: inHandoff });
                newLocation = getNewLocation(history, { pathname: pathname });
                history.push(newLocation, newLocationState);
                return [2 /*return*/];
        }
    });
}
function updateCurrentLocationState(history, newState) {
    var existingState = history.location.state || {};
    var newLocation = getNewLocation(history);
    history.replace(newLocation, __assign(__assign({}, existingState), newState));
}
function getNewLocation(history, newLocationProps) {
    if (newLocationProps === void 0) { newLocationProps = {}; }
    return __assign(__assign({}, cloneDeep(pick(history.location, ['pathname', 'search', 'hash']))), newLocationProps);
}
